import { render, staticRenderFns } from "./TripLegCostDetails.vue?vue&type=template&id=2789084a&"
import script from "./TripLegCostDetails.vue?vue&type=script&lang=js&"
export * from "./TripLegCostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports